import React from "react";

export function BookingBadge({ status }) {
  if (status === "open") return <span className="badge badge-open" data-testid="badge-open">Booking open</span>;
  if (status === "waitlist") return <span className="badge badge-waitlist" data-testid="badge-waitlist">Waitlist</span>;
  if (status === "flash") return <span className="badge badge-flash" data-testid="badge-flash">Flash sale</span>;
  return <span className="badge badge-neutral">{status || "—"}</span>;
}

export function PostTypeBadge({ type }) {
  const map = {
    inspiration: { label: "Inspiration", cls: "badge-open" },
    aftercare: { label: "Aftercare", cls: "badge-waitlist" },
    flash: { label: "Flash", cls: "badge-flash" },
    general: { label: "General", cls: "badge-neutral" },
  };
  const m = map[type] || map.general;
  return <span className={`badge ${m.cls}`}>{m.label}</span>;
}

export function AccountBadge({ type }) {
  if (type === "artist") return <span className="badge badge-flash">Artist</span>;
  return <span className="badge badge-neutral">Client</span>;
}
